import React, { ReactNode } from 'react';
import { Button } from '@material-ui/core';
import classNames from 'classnames';
import { useStyles } from './LinkButton.styles';
import Arrow from '../../../icons/Arrow';

export interface LinkButtonProps {
  disabled?: boolean;
  fullWidth?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  dataQaId: string;
  arrowType?: 'up' | 'down';
  children?: ReactNode;
  passedClassName?: string | null;
  endIcon?: boolean;
  ariaLabel?: string;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  disabled = false,
  fullWidth = false,
  onClick,
  dataQaId,
  arrowType = 'down',
  children,
  passedClassName = null,
  endIcon = true,
  ariaLabel = 'link-button',
}) => {
  const classes = useStyles();
  return (
    <Button
      variant="text"
      color="primary"
      className={classNames(classes.root, passedClassName)}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={onClick}
      data-qa-id={dataQaId}
      aria-label={ariaLabel}
      endIcon={endIcon && <Arrow type={arrowType} disabled={disabled} data-qa-id={`${dataQaId}-arrow-${arrowType}`} />}
    >
      {children}
    </Button>
  );
};

export default LinkButton;
